<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height="20"
    width="16"
  >
    <path d="M7.5 16q-.625 0-1.062-.438Q6 15.125 6 14.5t.438-1.062Q6.875 13 7.5 13t1.062.438Q9 13.875 9 14.5t-.438 1.062Q8.125 16 7.5 16Zm5 0q-.625 0-1.062-.438Q11 15.125 11 14.5t.438-1.062Q11.875 13 12.5 13t1.062.438Q14 13.875 14 14.5t-.438 1.062Q13.125 16 12.5 16Zm-5-4.5q-.625 0-1.062-.438Q6 10.625 6 10t.438-1.062Q6.875 8.5 7.5 8.5t1.062.438Q9 9.375 9 10t-.438 1.062q-.437.438-1.062.438Zm5 0q-.625 0-1.062-.438Q11 10.625 11 10t.438-1.062Q11.875 8.5 12.5 8.5t1.062.438Q14 9.375 14 10t-.438 1.062q-.437.438-1.062.438ZM7.5 7q-.625 0-1.062-.438Q6 6.125 6 5.5t.438-1.062Q6.875 4 7.5 4t1.062.438Q9 4.875 9 5.5t-.438 1.062Q8.125 7 7.5 7Zm5 0q-.625 0-1.062-.438Q11 6.125 11 5.5t.438-1.062Q11.875 4 12.5 4t1.062.438Q14 4.875 14 5.5t-.438 1.062Q13.125 7 12.5 7Z" />
  </svg>
</template>

<script>
export default {
  name: 'DragIndicator',
};
</script>
<style scoped lang="scss">
svg {
  fill: #aaa;
}
</style>
